<p-dialog
  [(visible)]="displayDialog"
  [resizable]="false"
  [showHeader]="false"
  [dismissableMask]="true"
  showeffect="fade"
  [modal]="true"
  [styleClass]="'add-dialog'"
  [blockScroll]="true"
>
  <div class="export-dialog-content">
    <h3 class="dialog-title">Export Options</h3>
    <p class="dialog-description">Choose a format to export your data:</p>
    <div class="button-group">
      <button class="export-button csv-button" type="button" (click)="export('CSV')">
        <i class="fa fa-file-text"></i> CSV
      </button>
      <button class="export-button pdf-button" type="button" (click)="export('PDF')">
        <i class="fa fa-file-pdf"></i> PDF
      </button>
    </div>
  </div>
</p-dialog>